"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);












var _smsDelivery = require('shared/services/smsDelivery');

// Everything staff read about "Consent to text" on the profile, in the
// Record consent dialog and in Resubscribe's "asked again". Web and mobile
// both render from here.

// A message's SMSDeliveryOutcomes status while its text waits for consent.
 const SMS_AWAITING_CONSENT_STATUS = 'awaiting_consent'; exports.SMS_AWAITING_CONSENT_STATUS = SMS_AWAITING_CONSENT_STATUS

// The chat's consent status lines (the server's bloom.ConsentLine* texts).
// Waiting reads amber and received reads green; any other line stays neutral.

const CONSENT_LINE_TONES = {
  'Waiting for consent': 'waiting',
  'Consent received': 'received',
}
 const consentLineTone = (text) => CONSENT_LINE_TONES[text]; exports.consentLineTone = consentLineTone

// The same tones for a contact's consent status (mobile's Consent card).
 const consentStatusTone = (status) =>
  status === 'consented' ? 'received' : status === 'waiting' ? 'waiting' : undefined; exports.consentStatusTone = consentStatusTone

 const CONSENT_LABEL = 'Consent'; exports.CONSENT_LABEL = CONSENT_LABEL
 const CONSENT_HISTORY_TITLE = 'Consent history'; exports.CONSENT_HISTORY_TITLE = CONSENT_HISTORY_TITLE
 const RECORD_CONSENT_LABEL = 'Record consent'; exports.RECORD_CONSENT_LABEL = RECORD_CONSENT_LABEL
 const RECORD_ASKED_AGAIN_LABEL = 'Record asked again'; exports.RECORD_ASKED_AGAIN_LABEL = RECORD_ASKED_AGAIN_LABEL
 const CONSENT_ASK_ADMIN_ASKED_AGAIN_COPY = 'An admin can record that they asked again.'; exports.CONSENT_ASK_ADMIN_ASKED_AGAIN_COPY = CONSENT_ASK_ADMIN_ASKED_AGAIN_COPY

const STATUS_LABELS = {
  consented: 'Consented',
  waiting: 'Waiting for YES',
  not_asked: 'Not asked yet',
  withdrawn: 'Withdrawn',
  asked_again: 'Asked again, waiting for START',
}

 const consentStatusLabel = (status) =>
  (status && STATUS_LABELS[status]) || STATUS_LABELS.not_asked; exports.consentStatusLabel = consentStatusLabel

 const CONSENT_HOW_OPTIONS = [
  { value: 'in_person', label: 'In person' },
  { value: 'by_phone', label: 'By phone' },
  { value: 'in_writing', label: 'In writing' },
]; exports.CONSENT_HOW_OPTIONS = CONSENT_HOW_OPTIONS

const howPhrase = (how) => {
  const label = _optionalChain([exports.CONSENT_HOW_OPTIONS, 'access', _ => _.find, 'call', _2 => _2(o => o.value === how), 'optionalAccess', _3 => _3.label])
  return label ? label.toLowerCase() : ''
}

// "Oct 30, 2026", from an RFC3339 time or a "YYYY-MM-DD" date.
 const formatConsentDate = (value) => {
  if (!value) return ''
  const m = /^\d{4}-\d{2}-\d{2}$/.test(value) ? _moment2.default.call(void 0, value, 'YYYY-MM-DD') : _moment2.default.call(void 0, value)
  return m.isValid() ? m.format('MMM D, YYYY') : ''
}; exports.formatConsentDate = formatConsentDate

// "Oct 30, 2026, 2:14 PM".
 const formatConsentTime = (value) => {
  if (!value) return ''
  const m = _moment2.default.call(void 0, value)
  return m.isValid() ? m.format('MMM D, YYYY, h:mm A') : ''
}; exports.formatConsentTime = formatConsentTime

// Today's local date as "YYYY-MM-DD", the default for "When?".
 const todayConsentDate = () => _moment2.default.call(void 0, ).format('YYYY-MM-DD'); exports.todayConsentDate = todayConsentDate

const joinParts = (parts) => parts.filter(Boolean).join(' · ')

// The grant that set the current status (the newest one), for who recorded it.
const newestGrant = (view) =>
  view.History.find(e => e.Kind === 'consent_granted')

// The Consent row's detail under the status: how and when they agreed.
 const consentMethodDetail = (
  view,
) => {
  const grant = newestGrant(view)
  const date = exports.formatConsentDate.call(void 0, view.MethodDate || view.Since)
  switch (view.Method) {
    case 'replied_yes':
      return joinParts(['Replied YES', date])
    case 'texted_us':
      return joinParts(['Texted us', date])
    case 'recorded':
      return joinParts([
        _optionalChain([grant, 'optionalAccess', _4 => _4.ActorName]) ? `Recorded by ${grant.ActorName}` : 'Recorded',
        howPhrase(_optionalChain([grant, 'optionalAccess', _5 => _5.How])),
        date,
      ])
    case 'imported':
      return joinParts(['Agreed before import', view.File || _optionalChain([grant, 'optionalAccess', _6 => _6.File]), _optionalChain([grant, 'optionalAccess', _7 => _7.ActorName]), date])
    case 'texting_before_consent_required':
      return joinParts(['Texting before consent was required', date])
    case 'asked_again':
      return joinParts(['Asked again', howPhrase(_optionalChain([grant, 'optionalAccess', _8 => _8.How])), date])
    default:
      return date
  }
}; exports.consentMethodDetail = consentMethodDetail

// "Covers Ben Able too (same phone)".
 const consentSharedWithCopy = (view) => {
  const names = (view.SharedWith || []).map(p => p.Name).filter(Boolean)
  return names.length ? `Covers ${_smsDelivery.joinNames.call(void 0, names)} too (same phone)` : ''
}; exports.consentSharedWithCopy = consentSharedWithCopy

// Web's "Record consent": while the setting is on and the contact hasn't
// agreed, opted out or asked again.
 const canRecordConsent = (view) =>
  !!_optionalChain([view, 'optionalAccess', _9 => _9.Enabled]) && view.Required
  && view.Status !== 'consented' && view.Status !== 'withdrawn' && view.Status !== 'asked_again'; exports.canRecordConsent = canRecordConsent

const GRANT_LABELS = {
  replied_yes: 'Replied YES',
  texted_us: 'Texted us',
  recorded: 'Consent recorded',
  imported: 'Agreed before import',
  texting_before_consent_required: 'Counted: texting before consent was required',
  asked_again: 'Asked again',
}

const KIND_LABELS = {
  consent_requested: 'Consent request sent',
  consent_granted: 'Consented',
  consent_released: 'Consent no longer required',
  opted_out: 'Texted STOP',
  opted_in: 'Texted START',
  staff_marked: 'Marked opted out',
  admin_cleared: 'Resubscribed by an admin',
}











 const describeConsentEvent = (event) => {
  // Unknown values from a newer server read as the raw value, never blank.
  const base = event.Kind === 'consent_granted'
    ? (event.Method && GRANT_LABELS[event.Method]) || KIND_LABELS.consent_granted
    : _nullishCoalesce(KIND_LABELS[event.Kind], () => ( event.Kind))
  const extra = [howPhrase(event.How), exports.formatConsentDate.call(void 0, event.Date), event.File].filter(Boolean).join(', ')
  const note = _optionalChain([event, 'access', _10 => _10.Note, 'optionalAccess', _11 => _11.trim, 'call', _12 => _12()]) || ''
  return {
    what: extra ? `${base} (${extra})` : base,
    who: _optionalChain([event, 'access', _13 => _13.ActorName, 'optionalAccess', _14 => _14.trim, 'call', _15 => _15()]) || '',
    when: exports.formatConsentTime.call(void 0, event.At),
    // A note that only repeats the label's reply word ("Replied YES", "YES")
    // adds nothing.
    note: base.split(' ').includes(note.toUpperCase()) ? '' : note,
  }
}; exports.describeConsentEvent = describeConsentEvent

// An opt-out the patient texted (STOP) on one of the org's lines: in a
// consent org an admin can record that they asked again; the block stays
// until they text START.
 const isTextedStop = (
  row,
) => !row.Shared && row.Reason === 'opted_out' && row.Source === 'patient_text'; exports.isTextedStop = isTextedStop

// The notice after an admin records "asked again".
 const makeAskedAgainSavedCopy = (patientName, line) =>
  `Recorded. ${_optionalChain([patientName, 'optionalAccess', _16 => _16.trim, 'call', _17 => _17()]) || 'The patient'}'s phone stays blocked until they text START. Ask them to text START to ${line}.`; exports.makeAskedAgainSavedCopy = makeAskedAgainSavedCopy

// The conversation banner in a consent org: a patient who texted STOP gets
// "Record asked again" for admins (it opens Resubscribe in its "asked again"
// form) and "An admin can record that they asked again." for everyone else.
 const withConsentAskedAgain = (
  copy,
  patients,
  isAdmin,
) => {
  const textedStop = new Set(patients.filter(p => exports.isTextedStop.call(void 0, p.row)).map(p => p.patient.PatientKey))
  if (!textedStop.size) return copy
  return {
    ...copy,
    entries: copy.entries.map(entry => {
      if (!textedStop.has(entry.patientKey)) return entry
      return isAdmin
        ? { ...entry, clearAction: 'ResubscribePatientSMS', clearLabel: exports.RECORD_ASKED_AGAIN_LABEL }
        : { ...entry, hint: exports.CONSENT_ASK_ADMIN_ASKED_AGAIN_COPY }
    }),
  }
}; exports.withConsentAskedAgain = withConsentAskedAgain

// ---------------------------------------------------------------------------
// The org's Consent tab

const contacts = (n) => `${n} ${n === 1 ? 'contact' : 'contacts'}`
const messages = (n) => `${n} ${n === 1 ? 'message' : 'messages'}`

// "On since Oct 30, 2026 · turned on by Amanda Price".
 const consentOnSinceCopy = (
  view,
) => {
  if (!view.Required) return ''
  const date = exports.formatConsentDate.call(void 0, view.ChangedAt)
  const by = _optionalChain([view, 'access', _18 => _18.ChangedByName, 'optionalAccess', _19 => _19.trim, 'call', _20 => _20()])
  return joinParts([date && `On since ${date}`, by && `turned on by ${by}`])
}; exports.consentOnSinceCopy = consentOnSinceCopy

// For "Count recent contacts": the attestation the admin confirmed.
 const consentAttestationCopy = (
  view,
) => {
  if (!view.Required || view.Mode !== 'count_recent') return ''
  return _optionalChain([view, 'access', _21 => _21.Attestation, 'optionalAccess', _22 => _22.trim, 'call', _23 => _23()]) || `${contacts(view.Counted)} counted as consented.`
}; exports.consentAttestationCopy = consentAttestationCopy








 const makeConsentTurnOnCopy = (
  counts,
) => {
  const others = Math.max(counts.Contacts - counts.Recent, 0)
  const org = counts.OrgName.trim() || 'my organization'
  return {
    question: `What about your ${counts.Contacts} existing ${counts.Contacts === 1 ? 'contact' : 'contacts'}?`,
    countRecent: `${contacts(counts.Recent)} texted with you in the last 12 months. `
      + 'They\'re recorded as "texting before consent was required". '
      + `The other ${others} ${others === 1 ? 'is' : 'are'} asked the next time your team texts them.`,
    attestation: `I confirm ${org} has consent to text these ${contacts(counts.Recent)}.`,
    askEveryone: counts.Contacts === 1
      ? 'Your 1 contact gets the consent request the next time your team texts them.'
      : `All ${counts.Contacts} get the consent request the next time your team texts them.`,
  }
}; exports.makeConsentTurnOnCopy = makeConsentTurnOnCopy

 const consentTurnOffCopy = (waiting) => {
  const what = waiting === null ? 'Messages' : messages(waiting)
  return `${what} waiting for consent ${waiting === 1 ? 'sends' : 'send'} now. Contacts keep the consent they gave.`
}; exports.consentTurnOffCopy = consentTurnOffCopy
